import {Slides as SlidesComponent, SlidesProps} from './Slides';
import {Slide, SlideProps} from './Slide';

export const Slides = Object.assign(SlidesComponent, {
    Slide
});

export type {
    SlideProps,
    SlidesProps
};